<template>
  <!-- PHASE 2 isShowFavButton = true -->
  <MobileHeader
    v-if="teamInfo.isFavTeam !== undefined"
    :isShowFavButton="scrollTop >= 45.59"
    :isFav="isFavTeam"
    @toggleFavThis="toggleFavTeam($event)"
    :mobileFilterPill="
      currentTabs === 1 ? mobileStandingSeasonFilter : mobileResultsSeasonFilter
    ">
  </MobileHeader>
  
  <div class="home">
    <div :class="!isMobile ? 'has-header container' : 'home-box'">

      <template v-if="isMobile">
        <Sticky
          :top="2"
          :show="60"
          :stickyShowBefore="false"
          stickyStyle="width: 44px;left: 50%;transform: translate3D(-50%, 0 , 0)">
          <Icon :logoUrl="teamInfo.logo" class="team-info__header-logo scroll_top_logo"></Icon>
        </Sticky>
      </template>

      <div class="header-container" v-if="isMobile"
            :class="{
              'no-border': [1,3,7].includes(currentTabs)
            }">
            <div class="team-info__header-wrapper">
              <Icon :logoUrl="teamInfo.logo" class="team-info__header-logo"></Icon>
              <div class="team-info__header-title-container">
                <div class="team-info__header-country">{{ teamInfo.country }}</div>
                <div class="team-info__header-title-wrapper">
                  <div class="team-info__header-title mr-05rem">
                    {{ teamInfo.name }}
                  </div>
                </div>
              </div>
              
              <FavStarButton
                class="normal flex-shrink"
                v-if="
                  teamInfo.isFavTeam !== undefined && isMobile && scrollTop < 45.59
                "
                :isFav="isFavTeam"
                @toggleFavThis="toggleFavTeam($event)"
              >
              </FavStarButton>
            </div>
    
    
      
            <!-- <Sticky
              :top="40"
              :show="40"
              :stickyShowBefore="true"
              ref="sticky2"
            > -->
              
            <!-- </Sticky> -->
      
            <!-- <div class="team-info__header-wrapper mb-2rem">
              <Icon :logoUrl="teamInfo.logo" class="team-info__header-logo"></Icon>
              <div class="team-info__header-title-container">
                <div class="team-info__header-country">{{ teamInfo.country }}</div>
                <div class="team-info__header-title-wrapper">
                  <div class="team-info__header-title mr-05rem">
                    {{ teamInfo.name }}
                  </div>
                  <FavStarButton
                    class="btn-fav normal"
                    v-if="teamInfo.isFavTeam !== undefined && !isMobile"
                    :isFav="isFavTeam"
                    @toggleFavThis="toggleFavTeam($event)"
                  >
                  </FavStarButton>
                </div>
              </div>
            </div> -->
          </div>

      <Sticky
          v-if="isMobile"
          :top="48"
          :show="48"
          :stickyShowBefore="true"
          ref="sticky2">
          <div class="display-flex-center tab-wrapper scroll_top_nav1"
            :class="{
              'has-border': ![1,3,7].includes(currentTabs)
            }">
              <router-link
                class="sub-nav__child"
                :to="{ path: `${o.path}` }"
                v-for="(o, index) in tabs"
                :key="index"
                @click="selectTabs(o)"
              >
                <span class="sub-nav__child-text">{{ $t(o.name) }}</span>
                <div class="sub-nav__child-indicator"></div>
              </router-link>
            </div>
    
            <div>
              <div
                class="nav-pill__wrapper sub-nav__child"
                v-if="currentTabObj.child && scrollTop > 45.59"
              >
                <div
                  class="nav-pill"
                  :class="{ selected: o.selected }"
                  v-for="(o, index) in currentTabObj.child"
                  :key="index"
                  @click="selectChildTabs(o, currentTabObj.child)"
                >
                  {{ $t(o.name) }}
                </div>
              </div>
            </div>
      </Sticky>

      
  
      <div class="header-container league-header" v-if="!isMobile">
        <div class="team-info__header-wrapper mb-1rem">
          <Icon :logoUrl="teamInfo.logo" class="team-info__header-logo"></Icon>
          <div class="team-info__header-title-container">
            
            <div class="team-info__header-title-wrapper">
              <div class="team-info__header-title mr-05rem">
                {{ teamInfo.name }}
              </div>
              <div class="btn-fav-aspn-circle pointer"
                v-if="teamInfo.isFavTeam !== undefined && !isMobile"
                @click="toggleFavTeam($event)"
                :class="{
                  'selected': isFavTeam
                }">
              </div>
              <!-- <FavStarButton
                class="btn-fav normal"
                v-if="teamInfo.isFavTeam !== undefined && !isMobile"
                :isFav="isFavTeam"
                @toggleFavThis="toggleFavTeam($event)"
              >
              </FavStarButton> -->
            </div>
            <div class="team-info__header-country">{{ teamInfo.country }}</div>
          </div>
  
          <!-- <div>
            <div class="nav-pill__wrapper filter-pill display-flex season-pill">
              <div class="relative">
                <div
                  class="nav-pill"
                  @click="handleSeasonBtn($event)"
                >
                  <span class="mr-1rem">{{
                    currentSeasonList.name.replace("-", "/")
                  }}</span>
                  <i
                    class="svg-arrow__vertical"
                    :class="{ selected: currentSeasonList.colored }"
                  >
                    <svg
                      width="13"
                      height="8"
                      viewBox="0 0 13 8"
                      class="league-dropdown__svg"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.74042 0.589996L6.53499 5.17L11.3296 0.589996L12.8024 2L6.53499 8L0.267578 2L1.74042 0.589996Z"
                        fill="inherit"
                      />
                    </svg>
                  </i>
                </div>
  
                <div
                  class="dropdown-wrapper"
                  :class="{ selected: currentSeasonList.isShowDropdown }"
                >
                  <perfect-scrollbar>
                    <div class="dropdown-container__wrapper">
                      <div
                        class="dropdown-container"
                        v-for="(o, index) in seasonList"
                        :key="index"
                        @click="handleSeasonDropdown(o, false)"
                      >
                        <div class="dropdown-container__name">
                          <span>{{ o.season.replace("-", "/") }} </span>
                        </div>
                        <div
                          class="dropdown-container__tick"
                          :class="{ selected: o.selected }"
                        ></div>
                        <TickMark v-if="o.selected" />
                      </div>
                    </div>
                  </perfect-scrollbar>
                </div>
              </div>
            </div>
          </div> -->
        </div>
  
        <div class="display-flex has-space pt-1rem tab-wrapper">
          <router-link
            class="sub-nav__child"
            :to="{ path: `${o.path}` }"
            v-for="(o, index) in tabsWeb"
            :key="index"
            @click="selectTabs(o)"
          >
            <span class="sub-nav__child-text">{{ $t(o.name) }}</span>
            <div class="sub-nav__child-indicator"></div>
          </router-link>
        </div>
      </div>
  
      <div class="container">
        <router-view :isLoading="isLoading">
          <template #header>
            <!-- <div v-if="!isMobile && currentTabObj.child" class="title-box">
              <div v-if="currentTabObj.titleName" class="title-name">
                {{ currentTabObj.titleName }}
              </div>
              <div class="nav-pill__wrapper sub-nav__child">
                <div
                  class="nav-pill"
                  :class="{ selected: o.selected }"
                  v-for="(o, index) in currentTabObj.child"
                  :key="index"
                  @click="selectChildTabs(o, currentTabObj.child)"
                >
                  {{ $t(o.name) }}
                </div>
              </div>
            </div> -->
          </template>
        </router-view>
      </div>
      <div class="container" style="display: none">
        <div v-show="currentTabs === 1">
          <div
            class="team-info__overview-card"
            v-for="(o, index) in overviewList"
            :key="index"
          >
            <div class="team-info__overview-header">{{ o.title }}</div>
            <div
              class="team-info__overview-body"
              v-for="(level2, index) in o.child"
              :key="index"
            >
              <div class="">{{ level2.key }}</div>
              <div class="">{{ level2.value }}</div>
            </div>
          </div>
  
          <div
            class="team-info__overview-card"
            v-for="(o, index) in overviewGoallList"
            :key="index"
          >
            <div class="team-info__overview-header">{{ o.title }}</div>
            <div class="team-info__overview-body__header">
              <div class="team-info__overview-goal__player">
                <div class="team-info__overview-goal__player-rank">#</div>
                <div>Player</div>
              </div>
              <div class="team-info__overview-goal__player-goal">Goal</div>
            </div>
  
            <div
              class="team-info__overview-body"
              v-for="(level2, index) in o.child"
              :key="index"
            >
              <div class="team-info__overview-goal__player">
                <div class="team-info__overview-goal__player-rank">
                  {{ level2.rank }}
                </div>
                <!-- <div class="team-info__overview-goal__player-img"><img src="../../../../static/images/icons/icon_goal_player.png"></div> -->
                <div class="team-info__overview-goal__player-name">
                  {{ level2.name }}
                </div>
              </div>
              <div class="team-info__overview-goal__player-goal">
                {{ level2.goal }}
              </div>
            </div>
          </div>
        </div>
        <div v-show="currentTabs === 2">
          <MatchContent
            :matchObj="matchObj"
            :isShowFav="true"
            class="container"
          ></MatchContent>
        </div>
        <div v-show="currentTabs === 3">
          <div class="nav-pill__wrapper mb-main container">
            <div class="nav-pill selected">Season 2020-2011</div>
          </div>
          <div
            class="team-info__overview-card"
            v-for="(o, index) in overviewList"
            :key="index"
          >
            <div class="team-info__overview-header">{{ o.title }}</div>
            <div
              class="team-info__overview-body"
              v-for="(level2, index) in o.child"
              :key="index"
            >
              <div class="">{{ level2.key }}</div>
              <div class="">{{ level2.value }}</div>
            </div>
          </div>
  
          <div
            class="team-info__overview-card"
            v-for="(o, index) in overviewGoallList"
            :key="index"
          >
            <div class="team-info__overview-header">{{ o.title }}</div>
            <div class="team-info__overview-body__header">
              <div class="team-info__overview-goal__player">
                <div class="team-info__overview-goal__player-rank">#</div>
                <div>Player</div>
              </div>
              <div class="team-info__overview-goal__player-goal">Goal</div>
            </div>
  
            <router-link
              :to="{ path: `/player/${level2.name}` }"
              class="team-info__overview-body"
              v-for="(level2, index) in o.child"
              :key="index"
            >
              <div class="team-info__overview-goal__player">
                <div class="team-info__overview-goal__player-rank">
                  {{ level2.rank }}
                </div>
                <!-- <div class="team-info__overview-goal__player-img"><img src="../../../../static/images/icons/icon_goal_player.png"></div> -->
                <div class="team-info__overview-goal__player-name">
                  {{ level2.name }}
                </div>
              </div>
              <div class="team-info__overview-goal__player-goal">
                {{ level2.goal }}
              </div>
            </router-link>
          </div>
        </div>
        <!-- <div  v-show="currentTabs === 4">       
            <MatchTable :matchTableList="matchTableList" :matchTableTipsList="matchTableTipsList"></MatchTable>
        </div> -->
      </div>
    </div>
  </div>
  <PopUpSignInIndexMobile
    ref="PopUpSignInIndexMobileRef"
    :title="$i18n.t('FAV_LOGIN_TITLE')"
    :message="$i18n.t('FAV_LOGIN_TIPS')"
    class="login-fav-popup"
  ></PopUpSignInIndexMobile>
  <!-- <FavLoginTips ref="favLoginTipsRef"></FavLoginTips> -->
</template>

<script>
import { reactive } from "vue";
import MobileHeader from "@/components/mobile/Header.vue";
import MatchContent from "@/components/MatchContent.vue";
import MatchTable from "@/components/match/football/Table.vue";
import FavStarButton from "@/components/ui/FavStarButton.vue";
import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";
import Sticky from "@/components/sticky/Sticky.vue";
import MobileSelect from "mobile-select"; //"@/lib/mobile-select"
import TickMark from "@/components/indicator/TickMark.vue";
import FavLoginTips from "@/components/favourite/TipsLogin.vue";

import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
let mobileSelectSeason; // defined mobile select dropdown component for season
export default {
  components: {
    MobileHeader,
    MatchContent,
    MatchTable,
    FavStarButton,
    PopUpSignInIndexMobile,
    Sticky,
    TickMark,
    FavLoginTips
  },
  provide() {
    return {
      getStandingHistory: this.getStandingHistory,
    };
  },
  data() {
    return {
      getStandingHistory: reactive({
        boolean: false,
        season: "",
      }),
      mobileHeaderTitle: "TEAM", //TEAM_INFO
      teamKey: "",
      tabs: [
        
        {
          name: "MATCHES",
          path: "matches",
          routeName: "footballTeamMatch", //footballTeamMatch
          value: 3,
          selected: false,
        },
        {
          name: "STANDINGS",
          path: "table",
          routeName: "footballTeamTable",
          value: 1,
          selected: false,
        },
        {
          name: "NEWS",
          path: "news",
          routeName: "footballTeamNews",
          value: 5,
          selected: true,
        },
        {
          name: "SQUAD",
          path: "squad",
          routeName: "footballTeamSquad",
          value: 4,
          selected: true,
        },
        {
          name: "TRANSFER",
          path: "transfer",
          value: 7,
          selected: false,
        },
      ],
      tabsWeb: [
        {
          name: "OVERVIEW",
          path: "overview",
          routeName: "footballTeamOverview", //footballTeamMatch
          value: 1,
          selected: true,
          titleName: "MATCHES",
          child: [
            {
              name: "FIXTURES",
              value: 5,
              selected: true,
            },
            {
              name: "RESULTS",
              value: 6,
              selected: false,
            },
          ],
        },

        {
          name: "SQUAD",
          path: "squad",
          routeName: "footballTeamSquad",
          value: 4,
          selected: false,
        },
        // {
        //   name: "PLAYER_STATS",
        //   path: "player-stats",
        //   routeName: "footballTeamPlayerStats",
        //   value: 5,
        //   selected: false,
        // },
        // {
        //   name: "TEAM_STATS",
        //   path: "team-stats",
        //   routeName: "footballTeamTeamStats",
        //   value: 3,
        //   selected: false,
        //   titleName: "TEAM_STATS",
        // },

        {
          name: "NEWS",
          path: "news",
          routeName: "footballNews",
          value: 4,
          selected: false,
        },
        {
          name: "TRANSFER",
          path: "transfer",
          value: 6,
          selected: false,
        },
      ],
      childTabs: [],
      currentTabs: 1,
      currentTabObj: {},
      currentChildTabs: 5,
      isFavTeam: false,
      mobileResultsSeasonFilter: {
        id: "seasonListId",
        show: false,
        content: "",
      },
      
      currentSeasonList: {
        name: "",
        isShowDropdown: false,
        colored: true, //false
      },
      seasonList: [],
      isLoading: false,
    };
  },
  created() {
    this.teamKey = this.$route.params.teamKey;
    this.initRouteRedirection();
  },
  computed: {
    ...mapState(["scrollTop"]),
    ...mapGetters([
      "teamInfo",
      "isMobile",
      "currentLocale",
      "isLogin",
      "currentPathName",
      "currentLanguageObj",
      "isMobileRealTime"
    ]),
  },
  watch: {
    currentLocale: {
      deep: true,
      handler(newVal, oldVal) {
        this.init();
        // this.getLeagueListForRankingTable(newVal.leagueIdList);
      },
    },
    isLogin: {
      deep: true,
      handler(newVal, oldVal) {
        this.init();
      },
    },
    "$route.name"(newVal, oldVal) {
      this.getSelectTab();
    },
    "$route.params.teamKey"(newVal) {
      this.teamKey = newVal;
      if(this.teamKey) {
        this.init();
      }
      // this.initRouteRedirection();
    },
    teamDatePickercallback(newVal, oldVal) {
      let indexArr = newVal.indexArr;
      let data = newVal.data;
      that.currentSeasonList.name = data[0].value;
      that.currentSeasonList.id = data[0].id;

      // if (that.currentSeasonList.id === "null") {
      //   that.currentSeasonList.colored = false;
      // } else {
      that.currentSeasonList.colored = true;
      // this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
      // }

      if (type === "standings") {
        if (that.currentSeasonList.id !== "null") {
          that.getPastSoccerLeagueRankingData(that.currentSeasonList.name);
        } else {
          that.getSoccerLeagueRankingData();
        }
      } else {
        let isGetSeasonData = true;
        that.getFixtureByLeagueData(isGetSeasonData);
      }

      //default first option value
      this.currentSeasonList.name = mobileSelectData[0].value;
      // this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
      mobileSelectSeason.locatePosition(0, 0);

      if (type === "standings") {
        this.getSoccerLeagueRankingData();
      } else {
        let isGetSeasonData = true;
        this.getFixtureByLeagueData(isGetSeasonData);
      }
    },
    isMobileRealTime() {
      this.initRouteRedirection()
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(["SET_LEAGUE_SEASON_LIST"]),
    ...mapActions([
      "getTeamInfo",
      "addFavTeam",
      "unFavTeam",
      "commonVerifyLogin",
      "favLoginTipsChangeEvent",
      "toastrFavChangeEvent",
      "popUpSignInModuleEvent",
      "getSeasonListByLeagueId",
      "getPastSoccerLeagueRanking",
    ]),
    init() {
      this.commonVerifyLogin();
      this.getTeamInfoData();
      this.getSelectTab();

    },
    initRouteRedirection() {
      if(this.$route.name === "footballTeamDetail") {
        const routeName = this.isMobile
          ? "footballTeamMatch"
          : "footballTeamOverview";
          
        setTimeout(() => {
          this.$router.replace({ name: routeName });
        }, 100)
      } else if(this.$route.name === 'footballTeamMatch' && !this.isMobileRealTime) {
        const routeName = "footballTeamOverview" 
        setTimeout(() => {
          this.$router.replace({ name: routeName });
        }, 100)
      } else if(this.$route.name === 'footballTeamOverview' && this.isMobileRealTime) {
        const routeName = "footballTeamMatch" 
        setTimeout(() => {
          this.$router.replace({ name: routeName });
        }, 100)
      }
      //  else if(this.$route.name === 'footballTeamMatch' && !this.isMobileRealTime) {
      //   const routeName = "footballTeamOverview" 
      //   setTimeout(() => {
      //     this.$router.replace({ name: routeName });
      //   }, 100)
      // }
    },
    async getTeamInfoData() {
      this.isLoading = true;
      let params = {
        teamId: this.teamKey,
      };
      const result = await this.getTeamInfo(params);

      let list = this.teamInfo.transfers
      for(var index in list) {
        let childList = list[index]
        for(var index2 in childList) {
          let childItem = childList[index2]
          for(var index3 in childItem) {
            let childItemData = childItem[index3]
            childItemData['generateDate'] = this.generateDate(childItemData.date)
            childItemData['dateRange'] = this.formatDateRange(childItemData.date, childItemData.endTime)
          }
        }
      }

      this.isFavTeam = this.teamInfo.isFavTeam;
      if (this.currentTabs === 1) {
        this.getSeasonListByLeagueIdData("standings");
      }
      this.isLoading = false;
    },

    generateDate(playerDate) {
        if(!playerDate) {
            return ''
        }
        let options = {
            // weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
        };
        playerDate = new Date(playerDate.split('.').reverse().join('-')); // Convert "05.09.2023" to "2023-09-05"
        let theDate = new Date(playerDate);
        return this.$tools.getDateByLocale(
            this.currentLanguageObj.apiParam.replace("_", "-"),
            options,
            theDate
        );
    },
    formatDateRange(date, endTime) {
        const startDate = new Date(date.split('.').reverse().join('-')); // Convert "05.09.2023" to "2023-09-05"
        const startMonth = this.$i18n.t(this.$tools.getMonth(startDate.getMonth()))
        const startYear = startDate.getFullYear();
        
        if(endTime) {
            const endDate = new Date(endTime);
            const endMonth = this.$t(this.$tools.getMonth(endDate.getMonth()))
            const endYear = endDate.getFullYear();

            return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
        }
        return `${startMonth} ${startYear}`;
        
    },
    async toggleFavTeam(data) {
      if (this.isLogin) {
        let params = {
          teamId: this.teamKey,
        };
        let paramsToastr = {
          isOpen: true,
          msg: this.teamInfo.name, //this.$i18n.t("TEAM")
          isAddedFav: false,
        };
        if (this.isFavTeam) {
          const result = await this.unFavTeam(params);
          if (result.message === "Success") {
            this.isFavTeam = false;

            paramsToastr.isAddedFav = false;
            this.toastrFavChangeEvent(paramsToastr);
          }
        } else {
          const result = await this.addFavTeam(params);
          if (result.message === "Success") {
            this.isFavTeam = true;

            paramsToastr.isAddedFav = true;
            this.toastrFavChangeEvent(paramsToastr);
          }
        }
      } else if (!this.isLogin && !this.isMobile) {
        // this.favLoginTipsChangeEvent({
        //   isOpen: true,
        //   event: data,
        //   callBackUrl: this.currentPathName,
        // });
        this.$refs.PopUpSignInIndexMobileRef.handleOpen();
      } else if (!this.isLogin && this.isMobile) {
        this.$refs.PopUpSignInIndexMobileRef.handleOpen();
      }
    },

    handleAuthentication(type) {
      this.popUpSignInModuleEvent(type);
      this.$refs.PopUpSignInIndexMobileRef.handleClose();
    },
    getSelectTab() {
      let routeName = this.$route.name;
      let founded = false;
      let tabs = this.isMobile ? this.tabs : this.tabsWeb;
      for (var index in tabs) {
        let tabItem = tabs[index];
        let tabRouteName = tabItem.routeName;
        if (routeName === tabRouteName) {
          tabItem.selected = true;
          this.currentTabs = tabItem.value;
          this.currentTabObj = tabItem;
          founded = true
          break;
        } else {
          tabItem.selected = false;
        }
      }
      
      if(!founded) {
        if(this.teamKey) {
          this.initRouteRedirection();
        }
        tabs[0].selected = true;
      }
    },
    // Mobile - set 'Matches > Results' filter pill
    setResultsFilterPill(toShow) {
      this.mobileResultsSeasonFilter.show = toShow;
    },
    //(Mobile) handle tabs
    selectTabs(o) {
      // if(this.isMobile) {

      let tabs = this.isMobile ? this.tabs : this.tabsWeb;
      tabs.forEach((x) => {
        x.selected = false;
      });

      o.selected = true;
      this.currentTabs = o.value;
      this.currentTabObj = o;
      if (this.isMobile) {
        // PHASE 2
        if (o.value === 1) {
          this.getSeasonListByLeagueIdData("standings");
        } else {
        }
      } else {
      }
      // }
    },
    selectChildTabs(o, list) {
      list.forEach((x) => {
        x.selected = false;
      });

      o.selected = true;
      if (o.value === 5 || o.value === 10) {
        this.handleReset();
        this.setResultsFilterPill(false);
        // this.$refs.sticky.checking()
        this.$refs.sticky2.checking()
      } else if (o.value === 6 || o.value === 11) {
        this.handleReset();
        this.setResultsFilterPill(true);
        this.getSeasonListByTeamIdData("");
        // this.$refs.sticky.checking(1)
        this.$refs.sticky2.checking(2)
      }
    },
    handleReset() {
      // this.clearFixtureByLeagueDataInterval();
      // if (this.isMobile) {
      //   // this.currentSubLeague.subLeagueName = this.subLeagueList[0].subLeagueName;
      //   this.currentSubLeague.subLeagueId = this.subLeagueList[0].subLeagueId;
      //   this.isResetMatchOptions = true;
      //   if (this.currentSubLeague.subLeagueId === "") {
      //     this.currentSubLeague.colored = false;
      //   } else {
      //     this.currentSubLeague.colored = true;
      //   }
      //   if (typeof mobileSelectSubLeague !== "undefined") {
      //     mobileSelectSubLeague.locatePosition(0, 0);
      //     document.querySelector("#subLeagueId").innerHTML = this.$i18n.t(
      //       this.subLeagueList[0].subLeagueName
      //     );
      //   }
      // } else {
      //   this.handleSubLeagueDropdown(this.subLeagueList[0], true);
      // }
      // this.isFirstTimeGetFixtureLeagueData = true;
      // if (
      //   (this.currentPrimaryTabs === 1 &&
      //     this.selectedCurrentChildMenu === "fixtures" &&
      //     !this.isMobile) ||
      //   (this.currentTabs === 1 &&
      //     this.selectedCurrentChildMenu === "fixtures" &&
      //     this.isMobile)
      // ) {
      //   this.handleMatchOptions(this.matchOptions[0]);
      //   this.initGetFixtureByLeagueDataInterval();
      // }
    },
    async getSeasonListByLeagueIdData(type = "default") {
      let params = {
        leagueId: this.teamInfo.leagueId,
      };
      let mobileSelectData = [];

      const result = await this.getSeasonListByLeagueId(params);

      result.result.forEach((x) => {
        x.selected = false;

        // (Mobile) insert subleague data to mobile select
        let mobileObj = {
          id: "",
          value: "",
        };
        mobileObj.id = x.season;
        mobileObj.value = x.season;

        mobileSelectData.push(mobileObj);
      });
      this.seasonList = result.result;
      // this.handleSeasonDropdown(this.seasonList[0]);
    },
    //(Desktop) Season dropdown select event
    handleSeasonDropdown(o) {
      if (this.isMobile) {
        return;
      }
      this.seasonList.forEach((x) => {
        x.selected = false;
      });
      o.selected = true;

      this.currentSeasonList.name = o.season;
      this.currentSeasonList.isShowDropdown = false;
      this.currentSeasonList.colored = true;
      if (this.isMobile) {
        this.mobileResultsSeasonFilter.content = o.season.replace("-", "/");
      }
      // this.currentSeasonList.subLeagueId = o.subLeagueId;

      // if (this.currentSeasonList.subLeagueId === '') {
      //     this.currentSeasonList.colored = false;
      // } else {
      //     this.currentSeasonList.colored = true;
      // }

      let isGetSeasonData = true;
      this.getStandingHistory.boolean = true;
      this.getStandingHistory.season = o.season;
      setTimeout(() => {
        this.getStandingHistory.boolean = false;
      }, 100);
      // this.getPastSoccerLeagueRankingData(o.season)

      // this.getFixtureByLeagueData(isGetSeasonData);
    },
    handleSeasonBtn(e) {
      this.currentSeasonList.isShowDropdown =
        !this.currentSeasonList.isShowDropdown;
      this.SET_LEAGUE_SEASON_LIST(this.currentSeasonList);
      e.stopPropagation();
    },
  },
};
</script>

<style scoped>
.header-container {
  background-color: var(--color-background-default-secondary);
}
.league-header {
  padding: 24px 24px 0 24px;
  margin-bottom: 24px;
  border-radius: var(--size-radius-400);
}
.team-info__header-wrapper {
  display: flex;
  justify-content: start;
  align-items: center;
  /* flex-direction: column; */
  /* margin-bottom: 2rem; */
}
.team-info__header-logo {
  /* margin-bottom: 1rem; */
  width: 83.35px;
  height: 83.35px;
  margin-right: 1.417rem;
  flex-shrink: 0;
}
.team-info__header-title-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.team-info__header-title {
  font-size: 32px;
	line-height: 120%;
  font-family: var(--weight-600);
	letter-spacing: -0.64px;
  color: var(--color-text-default-default);
}
.team-info__header-country {
  font-size: 16px;
  font-family: var(--weight-400);
  color: var(--color-text-default-secondary);
  margin-top: 4px;
	letter-spacing: 0.64px;
}
.team-info__overview-card {
  margin-bottom: 2rem;
}
.team-info__overview-header {
  margin: 0 1rem;
  margin-bottom: 0.5rem;
  font-size: 0.87rem;
  font-family: var(--weight-400);
}
.team-info__overview-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11.2px;
  padding: 0.5rem 0;
  border-bottom: 0.1rem solid #212b30;
  color: var(--color-grey-light);
  margin: 0 1rem;
}
.team-info__overview-body:hover .team-info__overview-goal__player-name {
  color: var(--color-hover);
}
.team-info__overview-body__header {
  display: flex;
  justify-content: space-between;
  background-color: var(--color-grey-20);
  padding: 0.5rem 1rem;
}
.team-info__overview-body:last-child {
  border-bottom: none;
}
.team-info__overview-body__left {
  flex: 1;
  text-align: left;
}
.team-info__overview-body__right {
  flex: 2;
  text-align: right;
}
.team-info__overview-goal__player {
  display: flex;
  align-items: center;
  font-size: 13.6px;
  flex: 2;
}
.team-info__overview-goal__player-rank {
  margin-right: 0.8rem;
  width: 1rem;
  text-align: center;
}
.team-info__overview-goal__player-img {
  border-radius: 50%;
  overflow: hidden;
  /* margin-right: 0.5rem; */
}
.team-info__overview-goal__player-goal {
  font-size: 13.6px;
}
@media(max-width: 768px) { /* for test */
  .team-info__header-wrapper {
    margin: 0 0rem 0;
    padding: 8px 8px;
    background-color: var(--color-background-default-secondary);
  }
  .team-info__header-logo {
    width: 36px;
    height: 36px;
    margin-right: 0.625rem;
  }
  .team-info__header-title-wrapper {
    margin-bottom: 0;
  }
  .team-info__header-title {
    font-size: 16px;
	  letter-spacing: 0.64px;
  }
  .team-info__header-country {
    font-size: 13px;
  }
}

.scroll_top_logo {
  left: 50%;
  transform: translateX(-50%);
  top: 2px;
  position: relative;
}

.scroll_top_fav {
  top: 4px;
  right: 8px;
}
.date-picker-container {
  background-color: red;
  width: 85px;
  height: 26px;
}
</style>

<style scoped>
.btn-fav-aspn {
  width: 22.83px;
  height: 21.8px;
}
.scroll_top_nav {
    top: 45px;
    border-bottom: 1px solid var(--color-border-default-default);
    width: 100%;
    background: var(--color-background-default-secondary);
    left: 0;
  }
.title-box {
  border-radius: 10px 10px 0 0;
  background-color: var(--white-1000);
  width: 608px;
  padding: 16px;
  padding-bottom: 0;
}
.title-name {
  font-family: var(--weight-700);
  font-size: var(--typography-body-size-large);
  margin-bottom: 16px;
  letter-spacing: 0.64px;
}
.sub-nav__child-indicator {
  margin-top: 8px;
}
.sub-nav__child .nav-pill {
  width: 100%;
  color: var(--color-text-default-default);
  padding: 8px 16px;
  border: 1px solid var(--color-border-default-default);
  font-size: 13px;
}
.btn-fav-circle {
  margin-left: auto;
  width: 40px;
  height: 40px;
}
@media(max-width: 768px) { /* for test */
  /* for test */
  .league-header {
        padding: 0 8px;
        border-radius: 0;
        padding-bottom: 16px;
        margin-bottom: 0;
    }
  .header-container {
    /* border-bottom: 1px solid var(--color-border-default-default); */
  }
  .tab-wrapper {
    align-items: baseline;
    width: calc(100% - 24px);
  }
  .nav-pill__wrapper {
    border-bottom: 1px solid var(--color-border-default-default);
  }
  .nav-pill {
  }
  .nav-pill:last-child {
    margin-right: 0;
  }
  .sub-nav__child .nav-pill {
    font-size: 13px;
  }
  .sub-nav__child .nav-pill:last-child {
    margin-right: 0 !important;
  }

  .sub-nav__child-indicator {
    margin-top: 14px;
  }
  .sub-nav__child {
    margin: 0.5rem 0.5rem 0 0.5rem;
  }
  .scroll_top_logo .team-info__header-logo {
    margin-right: 0 !important;
  }
  .home {
    padding-bottom: 16px;
    padding-top: 0;
    /* padding-top: calc(51.19px - 16px); */
    /* height: calc(100vh - 106px); */
  }
  .home-box {
    height: 100%;
    /* overflow-y: scroll; */
  }
  .has-border {
    border-bottom: 1px solid var(--color-border-default-default) !important;
  }
}
</style>

<style scoped>
.team-info__header-title-container {
  width: 100%;
}
.season-pill {
  padding: 0;
  /* background-color: transparent; */
}
.season-pill .nav-pill {
  margin-right: 0 !important;
  color: var(--color-text-default-default) !important;
  border: 1px solid var(--color-border-default-default) !important;
  background: var(--color-background-default-secondary) !important;
}
.season-pill .nav-pill:hover {
  background: var(--color-background-default-secondary) !important;
}
.mb-1rem {
  margin-bottom: 16px;
}
.scroll_top_nav1 {
  width: 100%;
  background: var(--color-background-default-secondary);
}
</style>
